<template>
    
</template>

<script>
    export default {
        name: "testapi",
        created(){
            this.$api.test.getTest({
                id:'asdf'
            }).then(data=>{
                console.log(data)
            })
            this.$api.test.getTestOne("123123").then(data=>{
                console.log(data)
            })
            this.$api.test.postTest({
                id:'asdf'
            }).then(data=>{
                console.log(data)
            })
            this.$api.test.putTest({
                id:'asdf'
            }).then(data=>{
                console.log(data)
            })
            this.$api.test.deleteTest("fhsdgfsdfg").then(data=>{
                console.log(data)
            })
        }
    }
</script>

<style scoped>

</style>